import { Button, Group, Text } from "@mantine/core";
import { modals } from "@mantine/modals";
import { IconCheck, IconX } from "@tabler/icons-react";
import Repository from "../../../_base/helper/HttpHelper";
import { NotificationExtension } from "../../../_base/extension/NotificationExtension";

const DeleteView = ({ idItem, onSearch }: DeleteProduct) => {
  const handleDeleteCollection = async () => {
    try {
      const repository = new Repository(process.env.REACT_APP_Demo_APP_API_URL);
      const res = await repository.post(`/TblKhung/delete`, idItem);

      if (res && res.success) {
        NotificationExtension.Success("Xóa thành công !");
        modals.closeAll();
        onSearch();
      } else {
        NotificationExtension.Fails("Xóa thất bại !");
        modals.closeAll();
      }
    } catch (error) {
      console.error("Lỗi khi xóa:", error);
      NotificationExtension.Fails("Có lỗi xảy ra khi xóa. Vui lòng thử lại!");
      modals.closeAll();
    }
  };

  return (
    <div>
      <Text size="24px">Bạn có muốn xoá bộ sưu tập này không?</Text>
      <Group justify="center" mt="lg">
        <Button
          type="button"
          color="#3598dc"
          onClick={handleDeleteCollection}
          leftSection={<IconCheck size={18} />}
        >
          Xóa
        </Button>
        <Button
          type="button"
          color="#3598dc"
          onClick={() => modals.closeAll()}
          leftSection={<IconX size={18} />}
        >
          Hủy
        </Button>
      </Group>
    </div>
  );
};

type DeleteProduct = {
  idItem: number[];
  onSearch: () => void;
};

export default DeleteView;
